import { Checkbox } from "@/components/ui/checkbox";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACTION_COLS = [
  { key: "view", label: "Visualizar" },
  { key: "create", label: "Incluir" },
  { key: "edit", label: "Editar" },
  { key: "delete", label: "Excluir" },
];

export const PermissionMatrix = ({ modules, value, onChange, readOnly = false }) => {
  const toggle = (mod, action, checked) => {
    const row = { ...(value[mod.key] || {}) };
    if (action === "view" && !checked) {
      ACTION_COLS.forEach((a) => { row[a.key] = false; });
    } else {
      row[action] = checked;
      if (checked) row.view = true;
    }
    onChange({ ...value, [mod.key]: row });
  };

  const toggleRow = (mod, checked) => {
    const row = {};
    ACTION_COLS.forEach((a) => { row[a.key] = checked && mod.actions.includes(a.key); });
    onChange({ ...value, [mod.key]: row });
  };

  return (
    <div className="border border-border rounded-lg overflow-x-auto" data-testid="permission-matrix">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="min-w-[180px]">Modulo</TableHead>
            {ACTION_COLS.map((a) => <TableHead key={a.key} className="text-center w-[90px]">{a.label}</TableHead>)}
            {!readOnly && <TableHead className="text-center w-[70px]">Tudo</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {modules.map((m) => {
            const row = value[m.key] || {};
            const all = m.actions.every((a) => row[a]);
            return (
              <TableRow key={m.key} className={row.view ? "" : "opacity-60"} data-testid={`perm-row-${m.key}`}>
                <TableCell className="text-sm font-medium">{m.label}</TableCell>
                {ACTION_COLS.map((a) => (
                  <TableCell key={a.key} className="text-center">
                    {m.actions.includes(a.key) ? (
                      <Checkbox checked={!!row[a.key]} disabled={readOnly}
                        onCheckedChange={(c) => toggle(m, a.key, !!c)} data-testid={`perm-${m.key}-${a.key}`} />
                    ) : <span className="text-muted-foreground text-xs">—</span>}
                  </TableCell>
                ))}
                {!readOnly && (
                  <TableCell className="text-center">
                    <Checkbox checked={all} onCheckedChange={(c) => toggleRow(m, !!c)} data-testid={`perm-${m.key}-all`} />
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
